// src/mixins/imageErrorHandler.js
import notfound from "@/assets/img/notfound.webp";

export default {
  mounted() {
    this.$nextTick(() => {
      // Only proceed if $el is an actual Element (not a fragment or comment)
      if (!(this.$el instanceof Element)) return;

      const imgs = this.$el.querySelectorAll("img");
      imgs.forEach((img) => {
        img.addEventListener("error", () => {
          if (img.src !== notfound) {
            img.src = notfound;
          }
        });
      });
    });
  },
};
